import { gql } from "@apollo/client"
import type { AdvisorKnowledgeBase, GetComponentProps } from "../../types"

export type Module = AdvisorKnowledgeBase<{
  name: string
  isoAlpha2Code: string
  visaRequired: boolean
}>

export const queryFragment: Module["queryFragment"] = gql`
  fragment kbVisaRequirement on CountryIntelligence {
    name
    isoAlpha2Code
    visaRequired(nationality: $nationality)
  }
`

export type KBVisaRequirement = GetComponentProps<Module["TranslationComponent"]>["data"]

export const shouldSkipFetch: Module["shouldSkipFetch"] = ({ gqlParams }) => {
  return !gqlParams?.nationality
}
